import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import gaTrackerMiddleware from 'config/analytics';
import reducer from 'reducers';
import promiseMiddleware from 'config/promiseMiddleware';
import localStorageMiddleware from 'config/localStorageMiddleware';

let middlewares;

switch (COUNTRY) {
  case 'LV':
  case 'FI':
  case 'MX':
  case 'LT':
  case 'CZ':
  case 'EE':
    middlewares = [promiseMiddleware, localStorageMiddleware, gaTrackerMiddleware];
    break;
  case 'AU':
  case 'PL':
    middlewares = [promiseMiddleware, gaTrackerMiddleware];
    break;
  default:
    middlewares = [promiseMiddleware, localStorageMiddleware];
}

if (COUNTRY === 'ES' && !PARTNER_PORTAL) {
  middlewares.push(gaTrackerMiddleware);
}

middlewares = [composeWithDevTools(applyMiddleware(...middlewares))];

const initialize = (initialState = {}) => {
  const store = createStore(reducer, initialState, compose(...middlewares));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers'); // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }
  return store;
};

export default initialize;
